import { EnumBody } from "@babel/types";

export interface ISort {
  direction: string;
  property: string;
}

export interface IPageable {
  offset: number;
  totalElements: number;
  totalPages: number;
  pageLimit: number;
  pageSize: number;
  pageNumber: number;
  first: boolean;
  last: boolean;
  sort: ISort;
}

export interface IBookingCounts {
  totalPast: number;
  totalToday: number;
  totalFuture: number;
  pagedPast: number;
  pagedToday: number;
  pagedFuture: number;
}

export interface ITraveller {
  type: string;
}

export interface IEco {
  co2: number;
  type: string;
  rating: number;
}

export interface IOrigin {
  name: string;
  type: string;
  id: string;
  extId: string;
  lon: number;
  lat: number;
  time: string;
  date: string;
  routeIdx?: number;
  prognosisType: string;
  hasMainMast?: boolean;
  mainMastId?: string;
  mainMastExtId?: string;
  mainMastLon?: number;
  mainMastLat?: number;
  entry?: boolean;
}

export interface IDestination {
  name: string;
  type: string;
  id: string;
  extId: string;
  lon: number;
  lat: number;
  time: string;
  date: string;
  routeIdx: number;
  prognosisType: string;
  hasMainMast?: boolean;
  mainMastId?: string;
  mainMastExtId?: string;
  mainMastLon?: number;
  mainMastLat?: number;
  entry?: boolean;
}

export interface IGisRef {
  ref: string;
}

export interface IGisRoute {
  dist: number;
  durS: string;
  dirGeo: number;
}

export interface IForegroundColor {
  r: number;
  g: number;
  b: number;
  hex: string;
}

export interface IBackgroundColor {
  r: number;
  g: number;
  b: number;
  hex: string;
}

export interface IIcon {
  foregroundColor: IForegroundColor;
  backgroundColor: IBackgroundColor;
  res: string;
}

export interface IProduct {
  icon: IIcon;
  name: string;
  internalName: string;
  displayNumber: string;
  num: string;
  line: string;
  lineId: string;
  catOut: string;
  catIn: string;
  catCode: string;
  cls: string;
  catOutS: string;
  catOutL: string;
  operatorCode: string;
  operator: string;
  admin: string;
  routeIdxFrom?: number;
  routeIdxTo?: number;
  matchId: string;
}

export interface IJourneyDetailRef {
  ref: string;
}

export interface IStop {
  name: string;
  id: string;
  extId: string;
  routeIdx: number;
  lon: number;
  lat: number;
  depTime: string;
  depDate: string;
  depDir: string;
  arrTime: string;
  arrDate: string;
}

export interface IStops {
  Stop: IStop[];
}

export interface IProduct2 {
  icon: IIcon;
  name: string;
  internalName: string;
  displayNumber: string;
  num: string;
  line: string;
  lineId: string;
  catOut: string;
  catIn: string;
  catCode: string;
  cls: string;
  catOutS: string;
  catOutL: string;
  operatorCode: string;
  operator: string;
  admin: string;
  matchId: string;
}

// export interface IJourney {
//     Stops: IStops;
//     JourneyDetailRef: IJourneyDetailRef;
//     Product: IProduct2;
//     name: string;
//     direction: string;
//     trainNumber: string;
//     trainCategory: string;
// }

export interface IFreq {
  waitMinimum: number;
  waitMaximum: number;
  alternativeCount: number;
  journey: IJourney[];
}

export interface INote {
  value: string;
  key: string;
  type: string;
  txtN: string;
}

export interface INotes {
  Note: INote[];
}

export interface IStop2 {
  name: string;
  id: string;
  extId: string;
  routeIdx: number;
  lon: number;
  lat: number;
  depTime: string;
  depDate: string;
  hasMainMast: boolean;
  mainMastId: string;
  mainMastExtId: string;
  mainMastLon: number;
  mainMastLat: number;
  depDir: string;
  entry: boolean;
  arrPrognosisType: string;
  arrTime: string;
  arrDate: string;
  depPrognosisType: string;
  Notes: INotes;
  alighting?: boolean;
}

export interface IStops2 {
  Stop: IStop2[];
}

export interface IJourneyDetail {
  dayOfOperation: string;
  ref: string;
}

export interface Leg {
  Origin: IOrigin;
  Destination: IDestination;
  GisRef: IGisRef;
  GisRoute: IGisRoute;
  Product: IProduct[];
  idx: number;
  name: string;
  type: string;
  duration: string;
  dist: number;
  JourneyDetailRef: IJourneyDetailRef;
  Freq: IFreq;
  JourneyStatus: string;
  Stops: IStops2;
  JourneyDetail: IJourneyDetail;
  number: string;
  category: string;
  reachable?: boolean;
  direction: string;
  directionFlag: string;
  isValidLeg?: boolean;
}

export interface ILegList {
  Leg: Leg[];
}

export interface IParam {
  name: string;
  value: string;
}

export interface IExternalContent {
  content: string;
  text: string;
  contentType: string;
}

export interface IGroup {
  type: string;
  child?: boolean;
  discount: string;
}

export interface ITicket {
  param: IParam[];
  externalContent: IExternalContent;
  name: string;
  price: number;
  cur: string;
  shpCtx: string;
  group: IGroup;
  desc: string;
}

export interface ITicket2 {
  context: string;
  idBook: string;
  price: IPrice;
  status: string;
  sessionDate: string;
  language: string;
  extras: IExtra[];
  bookingTime?: string;
  offerId?: string;
  invoiceDownloadUrl: string;
}

export interface IFareItem {
  ticket: ITicket[];
  param: IParam[];
}

export interface IFareSetItem {
  fareItem: IFareItem[];
  param: IParam[];
  name: string;
  fromLegId: number;
  toLegId: number;
}

export interface ITariffResult {
  fareSetItem: IFareSetItem[];
  param: IParam[];
}

export interface ITrip {
  Eco: IEco;
  Origin: IOrigin;
  LegList: ILegList;
  checksum: string;
  Destination: IDestination;
  TariffResult: ITariffResult;
  isValidTrip?: boolean;
}

export interface IActivity {
  session: any;
  activityDate: string;
  catalogueId: string;
  departureTime: string;
  name: string;
  details: IActivityDescription;
  url: string;
  languages:any
  price: {
    currency: string;
    gross: number;
    includedTaxes: number;
    taxes: number;
  };
  voucher: {
    voucherSequenceNumber: number;
    validityStartDatetime: string;
    validityEndDatetime: string;
    electronicCode: string;
  };
  numberOfVouchers: number;
}

export interface IRentingCardList {
  name: string;
  carStyle: string;
  date: string;
  collectionDate: string;
  createdDate?: string;
  idActivity: string;
  status: string;
  statusActivity: string;
  colorStatusActivity: string;
  borderStatusActivity: string;
  backgroundStatusActivity: string;
  chronology: string;
  price: string;
  image?: string;
  literals: {
    titleTag: string;
  };
  purchaseType: string;
  durationDay: number;
}

export interface IRenting {
  vehicle: IRentingVehicle;
  collection: IRentingCollection;
  devolution: IRentingDevolution;
  reference: string;
}

export interface IActivityDescription {
  details: IActivityDetails[];
  url: string;
}

export interface IActivityDetails {
  title: string;
  body: string;
}

export interface IPrice {
  total: number;
  gross: number;
  currency: string;
  concepts: any[];
  totalWithOutConcepts: number;
}

export interface IExtra {
  type: string;
  value: string;
}

export interface ISelectedTariff {
  idLeg: number;
  provider: string;
  contextType: string;
  price: IPrice;
  tickets: ITicket2[];
  orderId: string;
  status: string;
  id: string;
  paymentInfo?:any,
  orderFailedReason:string
}

export interface IJourney {
  trip: ITrip;
  activity: IActivity;
  experience: any;
  renting: IRenting;
  selectedTariff: ISelectedTariff[];
  originDate: Date;
  destinationDate: Date;
  completed: boolean;
  inProgress: boolean;
  price: IPrice;
}

export interface IBooking {
  id: number;
  plannification: boolean;
  chronology: string;
  createdDate: Date;
  travellers: ITraveller[];
  outwardJourney: IJourney;
  returnJourney?: IJourney; // Faltaría la vuelta
  price: IPrice;
}

export interface IData {
  pageable: IPageable;
  bookingCounts: IBookingCounts;
  bookings: IBooking[];
}

export interface IMyTripsResponse {
  data: IData;
  status: number;
}

export interface TripCardList {
  dest: string;
  location: string;
  date: string;
  orderid: string;
  departureTime: string;
  arrivalTime: string;
  numpassengers: string;
  transports: any;
  returnTicket?: boolean;
  fromdone?: boolean;
  selected?: boolean;
  currentTrip?: boolean;
  cancelation?: boolean;
  status?: string;
  todayTrip?: boolean;
  literals?:
    | { moreText: string; from: string; to: string; current: string }
    | any;
  isValidTrip?: boolean;
  chronology?: string;
  purchaseType: string;
}

export interface ActivityCardList {
  name: string;
  idActivity: string;
  date: string;
  status: string;
  chronology: string;
  currentTrip: boolean;
  purchaseType: string;
  price?: string;
  cancelation: boolean;
  departureDate?: string;
  departureTime?: string;
  sessionDate?: string;
  language: string;
  literals?: { 
    titleTag: string;
    diffDayLiterals: string;
    diffDaysLiterals: string;
 };
  passengers: number;
  statusActivity: string;
  colorStatusActivity: string;
  backgroundStatusActivity?: string;
  borderStatusActivity?: string;
  iconStatusActivity?: string;
  img: string;
  orderid:string;
  electronicCode:string
}

export enum ETransportLiterals {
  metro = "Metro",
  ave = "AVE Larga distancia",
  bici = "Bici",
  busUrb = "Autobús urbano",
  cooltra = "Cooltra",
  reby = "Reby",
  taxi = "Taxi",
  cercanias = "Cercanias",
}

export enum ItemType {
    MYTRIPS = 'myTrips',
    MYPASTTRIPS = 'myPastTrips',
    PLAN = 'plan',
    LONGMOVER='longMover',
    TODAY='today',
    PAST="past",
    FUTURE="future"
}

export enum ETypeTransport {
  paid = "PaidTransport",
  info = "InfoTransport",
  none = "",
}

export interface IDeletePstBody {
  idJourney: string;
  directionTrip: "OUTWARD" | "RETURN";
  transportTypeString?: string;
  trip: {
    idx: string;
    orderId: string | null;
    parameters: any[] | null;
  };
}
export interface IBodyDeleteJourney {
  idx: string;
  direction: "OUTWARD" | "RETURN";
  orderId: string | null | undefined;
  idBooks?: string[] | null | undefined;
  parameters?: any[] | null | undefined;
}
export interface IEntryDataDeletion {
  data: IDeletePstBody;
  orderId: any | undefined;
  idBooks: any[] | undefined;
  noteDriverComment?: string | undefined;
}

export interface IDetailActivity {
  idBooking: number;
  idActivity: string;
  name?: string;
  variantSummary: string;
  activitySummary: IActivitySummary;
  activityInfo: IActivityInfo[];
  activityValidationTicket: IValidationTicketInfo;
  orderId:string;
  electronicCode:string;
  literalStatus?:string;
  literalBannerDiscount?:string;
}
export interface IDetailRenting {
  reference: number;
  idBook: string;
  orderId: string;
  rentingSummary: IRentingSummary;
  rentingInfo: IRentingInfo;
  tripId: number;
}

export interface IRentingSummary {
  statusId: string;
  rentingReservation: IRentingReservation;
  rentingPriceSummary: IRentingPriceSummary;
  rentingCreatedReservation?: IRentingCreatedReservation;
}

export interface IRentingReservation {
  collection: {
    point: string;
    date: string;
    time: string;
  };
  devolution: {
    point: string;
    date: string;
    durationDay?: number;
    time: string;
  };
  statusRenting?: string;
  colorStatusRenting?: string;
  backgroundStatusRenting?: string;
  borderStatusRenting?: string;
}

export interface IRentingPriceSummary {
  totalPrice: string;
  priceVehicle: string;
  priceKms: string;
  priceInsurance: string;
  priceExtras: string;
  priceKmsName: string;
  priceInsuranceName: string;
}

export interface IRentingCreatedReservation {
  date: string;
  time: string;
}

export interface IActivitySummary {
  voucherSequenceNumber: number;
  numbersTravellers: number;
  statusActivity: string;
  statusId: string;
  colorStatusActivity: string;
  backgroundStatusActivity: string;
  borderStatusActivity: string;
  price: string;
  language: string;
  createdDate: string;
  bookingTime: string;
  totalPrice: string;
  idBook: string;
  orderId: string;
  timeCreated: string;
  urlReceipt: string;
  discount?:string;
  discountsNoString?:number
  electronicCode?:string;
  literalStatus?:string;
  showBannerDiscount?:boolean;
  literalBannerDiscount?:string;
  chronology?:string
  paymentInfo?:any
}

export interface IActivityInfo {
  title: string;
  body: string;
}

export interface IRentingInfo {
  vehicle: IVehicleInfo;
}

export interface IVehicleInfo {
  carName: string;
  image: string;
  carStyle: string;
  isAutomatic: boolean;
  isElectric: boolean;
  electricMaxRange: number;
  bags: number;
  passengers: number;
  ageDriver: number;
  total: string;
  totalForDay: string;
  insuranceServices: IVehicleService;
  kmsServices: IVehicleService;
  extras: IVehicleService[];
}

export interface IVehicleService {
  amount: string;
  name: string;
  description?: string;
}

export interface IRentingVehicle {
  name: string;
  imageUrl: string;
  model: string;
  isAutomatic: boolean;
  isElectric: boolean;
  maxRangeKm: number;
  bags: number;
  maxPassengers: number;
  ageDriver: number;
  totalForDay: number;
  total: number;
  services: IRentingService[];
  extras: IRentingService[];
}

export interface IRentingService {
  name: string;
  description?: string;
  amount: number;
}

export interface IRentingCollection {
  nameLocation: string;
  dateLocation: string;
}

export interface IRentingDevolution {
  nameLocation: string;
  dateLocation: string;
  durationDay: number;
}

export interface IValidationTicketInfo {
  idActivity: string;
  issueDate: string;
  printValidityDate: string;
  isTravelCard: boolean;
  qrCode: string;
}

export enum SummaryType {
  MYACTIVITIES = "myActivities",
  MYSCHEDULEDACTIVITIES = "myScheduledActivities",
  MYPASTACTIVITIES = "myPastActivities",
}


export interface IMappingPaymentCards {
  number: string;
  date: string;
  icon: string;
  name: string;
  status: string;
  provider: string;
  ticket:any;
  text:string;
  isXpay:boolean;
  orderFailedReason:any

}


